const RESERVED_PATH_PREFIXES = ['/checkout', '/checkouts', '/stores', '/kiosks', '/embedded-menu', '/_next'] as const;

/** Paths owned by checkout/menu/runtime routing and unavailable to authored CMS pages. */
export function isReservedCmsPath(path: string): boolean {
  const normalized = path.trim().replace(/\/+$/, '') || '/';
  return RESERVED_PATH_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`));
}

export const RESERVED_CMS_PATH_ERROR =
  'This path is reserved for Dutchie storefront functionality. Choose a different page path.';

export const CMS_PATH_REGEX = /^\/(?:[a-z0-9]+(?:[/\-_][a-z0-9]+)*\/?)?$/;

/**
 * Strips ALL trailing slashes from a urlPath (to a fixed point), except for the bare root path,
 * which is left as `/`.
 */
export function normalizeUrlPath(urlPath: string): string {
  const stripped = urlPath.replace(/\/+$/, '');
  return stripped === '' ? '/' : stripped;
}

/** Validates a URL path for CMS standalone pages. Returns an error message string or null if valid. */
export function validatePath(path: string): string | null {
  if (!path) return 'Path is required';
  if (!path.startsWith('/')) return 'Must start with /';
  if (/[?#]/.test(path)) return 'Query params and fragments are not allowed';
  if (/:\/\//.test(path)) return 'Must be a relative path, not a full URL';
  if (isReservedCmsPath(path)) return RESERVED_CMS_PATH_ERROR;
  if (!CMS_PATH_REGEX.test(path)) return 'Only lowercase letters, numbers, hyphens, underscores, and slashes';
  return null;
}

export function isValidPath(path: string): boolean {
  return validatePath(path) === null;
}
